module.exports = __webpack_public_path__ + "static/media/icon-profile-active.b0179dac.svg";